import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.transfers.item.background,
      padding: `${spacing.m}px ${spacing.s}px`,
      borderRadius: constants.radius.view,
      userSelect: "none",
    },
    subtitle: {
      color: theme.text.secondary,
    },
    inner: {
      alignItems: "space-between",
    },
    left: {
      marginLeft: spacing.m,
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
    },
    right: {
      marginRight: spacing.m,
      display: "flex",
      flexDirection: "column",
    },
    amount: {
      textAlign: "right",
    },
    secondary: {
      color: theme.text.secondary,
      textAlign: "right",
    },
    goalLabel: {
      color: theme.exclusive.inverse.text,
      backgroundColor: theme.exclusive.inverse.background,
      fontSize: 12,
      fontWeight: 600,
      borderRadius: 4,
      padding: 3,
      display: "flex",
      marginLeft: spacing.xs,
    },
    exclusive: {
      flex: undefined,
      flexShrink: undefined,
    },
  };

  return styles;
};
